module.exports = __webpack_public_path__ + "static/media/galerija_2022_0009.28a24bbf.jpg";